export enum PeerGroupType {
    Bespoke,
    Dynamic,
    All
}
